<template>
  <BaseModal
    :model-value="modelValue"
    :title="title"
    :subtitle="subtitle"
    :closable="closable"
    :size="size"
    :z-index-class="zIndexClass"
    :body-aria-label="bodyAriaLabel"
    :track-scroll-end="trackScrollEnd"
    :scroll-tracking-key="scrollTrackingKey"
    @update:model-value="emit('update:modelValue', $event)"
    @scroll-end-change="emit('scroll-end-change', $event)"
  >
    <template #headerIcon>
      <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-[rgb(var(--tenant-brand-50)/1)] text-[rgb(var(--tenant-brand-700)/1)] dark:bg-[rgb(var(--tenant-brand-950)/0.7)] dark:text-[rgb(var(--tenant-brand-300)/1)]">
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 2.75l1.52 4.73 4.73 1.52-4.73 1.52L12 15.25l-1.52-4.73L5.75 9l4.73-1.52L12 2.75zM18.5 14l.88 2.62L22 17.5l-2.62.88L18.5 21l-.88-2.62L15 17.5l2.62-.88L18.5 14zM5.5 14l.63 1.87L8 16.5l-1.87.63L5.5 19l-.63-1.87L3 16.5l1.87-.63L5.5 14z" />
        </svg>
      </div>
    </template>

    <div class="mb-5 flex flex-wrap items-center gap-2">
      <span class="rounded-full bg-[rgb(var(--tenant-brand-50)/1)] px-3 py-1 text-xs font-semibold uppercase tracking-[0.12em] text-[rgb(var(--tenant-brand-700)/1)] dark:bg-[rgb(var(--tenant-brand-950)/0.7)] dark:text-[rgb(var(--tenant-brand-300)/1)]">
        {{ eyebrow }}
      </span>
      <span v-if="versionLabel" class="text-xs font-medium text-gray-500 dark:text-gray-400">
        {{ versionLabel }}
      </span>
    </div>

    <slot />

    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '@/components/base/BaseModal.vue'

withDefaults(defineProps<{
  modelValue: boolean
  title: string
  subtitle?: string
  eyebrow: string
  versionLabel?: string
  closable?: boolean
  size?: 'sm' | 'md' | 'lg' | 'xl'
  zIndexClass?: string
  bodyAriaLabel?: string
  trackScrollEnd?: boolean
  scrollTrackingKey?: string | number
}>(), {
  subtitle: undefined,
  versionLabel: undefined,
  closable: true,
  size: 'lg',
  zIndexClass: 'z-[190]',
  bodyAriaLabel: undefined,
  trackScrollEnd: false,
  scrollTrackingKey: '',
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  'scroll-end-change': [value: boolean]
}>()
</script>
